// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibCardItem_old-container__Vblm3 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibCardItem_old-container__Vblm3.nibCardItem_wrap__77CBO {
  flex-wrap: wrap;
}
.nibCardItem_old-container__Vblm3 .nibCardItem_box__1GovB.nibCardItem_col__mN9Et {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibCardItem_old-container__Vblm3 .nibCardItem_box__1GovB.nibCardItem_col__mN9Et > div {
  width: 100%;
}
.nibCardItem_old-container__Vblm3 .nibCardItem_box__1GovB.nibCardItem_row__2Du1y {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibCardItem_old-container__Vblm3 form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibCardItem_old-container__Vblm3 form > .nibCardItem_box__1GovB.nibCardItem_col__mN9Et {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibCardItem_old-container__Vblm3 form > .nibCardItem_box__1GovB.nibCardItem_col__mN9Et {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibCardItem_old-container__Vblm3, .nibCardItem_col__mN9Et, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibCardItem_old-container__Vblm3, .nibCardItem_col__mN9Et, form {
    padding: 0px;
  }
}
.nibCardItem_text-overflow-hidden__kdRL\\+ {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibCardItem_icon__1U67c {
  color: var(--accent-color);
}

.nibCardItem_richtext-output-wrap__EbLHo .nibCardItem_se-video-container__-rWy3 figure {
  padding-bottom: 0 !important;
}

.nibCardItem_wrap__77CBO {
  width: 100%;
  min-height: 56px;
  box-shadow: -5px 5px 10px 0px rgba(0, 0, 0, 0.35);
  padding: 5px;
  margin: 10px 0px;
  background-color: #212121;
  border-radius: 6px;
}
.nibCardItem_wrap__77CBO .nibCardItem_header__OcufJ {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;
}
.nibCardItem_wrap__77CBO .nibCardItem_header__OcufJ strong {
  color: var(--accent-color);
}
.nibCardItem_wrap__77CBO .nibCardItem_header__OcufJ ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-height: 20px;
  height: 20px;
  transform: translate(15px, calc(-50% - 5px));
  margin-left: auto;
}
.nibCardItem_wrap__77CBO .nibCardItem_header__OcufJ ul li.nibCardItem_active__LjGg\\+ button svg {
  color: var(--accent-color);
}
.nibCardItem_wrap__77CBO .nibCardItem_header__OcufJ ul li button {
  margin: 0;
  padding: 2.5px;
}
.nibCardItem_wrap__77CBO p {
  text-align: right;
}
.nibCardItem_wrap__77CBO .nibCardItem_content__l3mUp {
  padding: 10px 0px;
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibCard/NibCardItem/nibCardItem.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,WAAA;EACA,gBAAA;EDIF,iDAAA;ECFE,YAAA;EACA,gBAAA;EACA,yBDoB8B;ECnB9B,kBAAA;AA4EJ;AA3EI;EDRF,aAAA;EACA,mBCQY;EDPZ,8BCOiB;EDNjB,mBCMgC;EAC1B,mBAAA;AAgFR;AA/EQ;EACI,0BDIH;AC6ET;AA9EQ;EDfN,aAAA;EACA,mBCegB;EDdhB,uBCcqB;EDbrB,mBCa6B;EACnB,gBAAA;EACA,YAAA;EACA,4CAAA;EACA,iBAAA;AAmFZ;AA/EwB;EACI,0BDTnB;AC0FT;AAhFgB;EACI,SAAA;EACA,cAAA;AAkFpB;AAjFI;EACI,iBAAA;AAmFR;AAlFI;EACI,iBAAA;AAoFR","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../../sass/settings'\n\n.wrap\n    width: 100%\n    min-height: 56px\n    +shadow()\n    padding: 5px\n    margin: calc($gutter/2) 0px\n    background-color: $container_item_background_color\n    border-radius: 6px\n    .header\n        +flex(row, space-between, center)\n        padding-right: 50px\n        strong\n            color: $accent\n        &.noName\n\n        ul\n            +flex(row, center, center)\n            max-height: 20px\n            height: 20px\n            transform: translate(15px, calc(-50% - 5px))\n            margin-left: auto\n            li\n                &.active\n                    button\n                        svg\n                            color: $accent\n                button\n                    margin: 0\n                    padding: 2.5px\n    p\n        text-align: right\n    .content\n        padding: 10px 0px\n            \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibCardItem_old-container__Vblm3`,
	"wrap": `nibCardItem_wrap__77CBO`,
	"box": `nibCardItem_box__1GovB`,
	"col": `nibCardItem_col__mN9Et`,
	"row": `nibCardItem_row__2Du1y`,
	"text-overflow-hidden": `nibCardItem_text-overflow-hidden__kdRL+`,
	"icon": `nibCardItem_icon__1U67c`,
	"richtext-output-wrap": `nibCardItem_richtext-output-wrap__EbLHo`,
	"se-video-container": `nibCardItem_se-video-container__-rWy3`,
	"header": `nibCardItem_header__OcufJ`,
	"active": `nibCardItem_active__LjGg+`,
	"content": `nibCardItem_content__l3mUp`
};
export default ___CSS_LOADER_EXPORT___;
